import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

// Suspend le tiré-pour-rafraîchir natif le temps d'une interaction verticale
// dans la page (mode Organiser : drag des produits et des sections). Sur
// Android, le conteneur natif intercepte tout geste vertical quand la page
// est en haut, avant même que SortableJS puisse l'annuler — le drag
// déclenchait le rafraîchissement. Sur iOS, le composant n'est pas déclaré :
// send() y est sans effet.
//
// Branché par data-action sur les événements du contrôleur sortable :
//   sortable:activated -> #disable, sortable:deactivated -> #enable.
export default class extends BridgeComponent {
  static component = 'pull-to-refresh'

  disable() {
    this.#send(false)
  }

  enable() {
    this.#send(true)
  }

  // Page quittée en plein mode Organiser : on rend le rafraîchissement.
  disconnect() {
    if (this.#disabled) this.#send(true)
    super.disconnect()
  }

  #disabled = false

  #send(enabled) {
    this.#disabled = !enabled
    this.send(enabled ? 'enable' : 'disable', { enabled })
  }
}
